export { ImageGallery } from './index.pc'
export { MobileImageGallery } from './index.mobile'
